module.exports = __webpack_public_path__ + "static/media/T1-Firebase.04df79aa.svg";